import React, { useState, useEffect, useCallback } from 'react';
import { getPendingSellers, verifySeller } from '../../services/adminService';
import { FaCheckCircle, FaTimesCircle, FaSpinner } from 'react-icons/fa';

const SellerVerification = () => {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [updating, setUpdating] = useState({}); // To track loading state for each seller row

  const fetchSellers = useCallback(async () => {
    try {
      setLoading(true);
      const pendingSellers = await getPendingSellers();
      setSellers(pendingSellers);
      setError('');
    } catch (err) {
      setError(err.message);
      setSellers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSellers();
  }, [fetchSellers]);

  const handleVerification = async (uid, status) => {
    setUpdating(prev => ({ ...prev, [uid]: true }));
    setError('');
    try {
      await verifySeller(uid, status);
      // Refresh the list by filtering out the user who was just actioned
      setSellers(prevSellers => prevSellers.filter(seller => String(seller.id) !== String(uid)));
    } catch (err) {
      setError(`Failed to verify seller ${uid}: ${err.message}`);
    } finally {
      setUpdating(prev => ({ ...prev, [uid]: false }));
    }
  };

  return (
    <div>
      <div className="admin-page-header">
        <h1>Seller Verification</h1>
        <p>Review and approve or reject new professional seller applications.</p>
      </div>

      <div className="admin-card">
        {loading && <div className="loading-spinner"><FaSpinner /> Loading sellers...</div>}
        {error && <div className="admin-error-message">Error: {error}</div>}
        {!loading && !error && (
          <div className="admin-table-container">
            {sellers.length > 0 ? (
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Display Name</th>
                    <th>User ID</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {sellers.map(seller => (
                    <tr key={seller.id}>
                      <td>{seller.email}</td>
                      <td>{seller.displayName || 'N/A'}</td>
                      <td>{seller.id}</td>
                      <td className="actions-cell">
                        <button 
                          className="admin-btn admin-btn-success" 
                          onClick={() => handleVerification(seller.id, 'approved')}
                          disabled={updating[seller.id]}
                        >
                          {updating[seller.id] ? <FaSpinner className="spinning"/> : <FaCheckCircle />} Approve
                        </button>
                        <button 
                          className="admin-btn admin-btn-danger" 
                          onClick={() => handleVerification(seller.id, 'rejected')}
                          disabled={updating[seller.id]}
                        >
                          {updating[seller.id] ? <FaSpinner className="spinning"/> : <FaTimesCircle />} Reject
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="admin-empty-state">
                <p>No sellers are currently pending verification.</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SellerVerification;